import { environmentServiceSiteConfig } from '@wix/viewer-services-configs'

const name = 'environmentService'

export const config = { site: environmentServiceSiteConfig, reactNativeSite: environmentServiceSiteConfig, name }
